import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { NotificationsView } from "@/features/academy/components/community/notifications-view";

// F3-C: bandeja de notificaciones + logros (badges).
export const notificationsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/notifications",
  component: NotificationsView,
});
